module.exports = __webpack_public_path__ + "static/2-fc0792f60f210f43f12527af9f2365db.jpg";